import * as Yup from 'yup';

import { passwordRegex } from '../../constants';

export const changePasswordYopValidation = () => {
  return Yup.object().shape({
    password: Yup.string().required('required').min(15, 'min15').matches(passwordRegex, 'passwordPattern'),
    repeatPassword: Yup.string()
      .required('required')
      .oneOf([Yup.ref('password')], 'passwordNotMatch'),
  });
};

export const changeUserPasswordYopValidation = () => {
  return Yup.object().shape({
    oldPassword: Yup.string().required('required'),
    password: Yup.string().required('required').min(15, 'min15').matches(passwordRegex, 'passwordPattern'),
    repeatPassword: Yup.string()
      .required('required')
      .oneOf([Yup.ref('password')], 'passwordNotMatch'),
  });
};
